import React, { Suspense } from "react";
import t from "../../../i18n";
import { useProject } from "../../../api/useProjects";
import { useParams } from "react-router";
import { useHandle } from "../../../router/helpers/handle";

export const ProjectName = () => {
  const { projectId } = useParams();
  if (!projectId) throw new Error();
  const project = useProject(projectId);
  return <Suspense>{project?.name ?? t("project.not_found.title")}</Suspense>;
};

const AppHeaderTitle = () => {
  const title = useHandle("title");
  return title?.() ?? null;
};

export default AppHeaderTitle;
